import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { connect as connectStaticText } from '../../StaticText/connect'
import GaiaLogo, { TYPE_TEAL } from '../../GaiaLogo/index'
import Button, { TYPES } from '../../Button/index'
import { getConfirmationFinishUrl } from '../../../services/url/index'
import { PLAN_CATEGORY_AI_ONLY } from '../../../services/plans/index'
import Icon, { ICON_COLORS } from '../../Icon/index'
import ArrowRightIcon from '../../Icon/icons/ArrowRight/index'
import { getUserName } from '../../../services/user/index'

/**
 * Component to handle the confirmation
 * @param {Map} props.staticText - Static text translations
 * @param {Map} props.onboarding - Onboarding state
 * @param {Map} props.userAccount - User account state
 * @param {Map} props.user - User state
 */
function CartSinglePageConfirmation (props) {
  const {
    staticText,
    onboarding,
    userAccount,
    user,
  } = props

  const planCategory = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'plan', 'planCategory']) || null
  const isAiOnly = planCategory === PLAN_CATEGORY_AI_ONLY
  const onboardingCompleted = onboarding.get('completed')

  const displayName = user.getIn(['updateUser', 'firstName'])
    || user.getIn(['data', 'firstName'])
    || getUserName(user.get('data'))
  const trimmed = (displayName || '').trim()
  const confirmationTitle = trimmed
    ? staticText.getIn(['data', 'welcomeBackTitle']).replace(/\$\{ firstName \}/, trimmed)
    : staticText.getIn(['data', 'welcomeBackTitleNoName'])

  return (
    <div className="cart-single-page__confirmation">
      <div className="cart-single-page__confirmation-background">
        <div className="cart-single-page__confirmation-overlay"></div>
      </div>
      <div className="cart-single-page__confirmation-container">
        <GaiaLogo
          type={TYPE_TEAL}
          className={['winback__logo']}
          isHref={false}
        />
        <div className="cart-single-page__confirmation-content">
          <div className="cart-single-page__confirmation-title">
            {confirmationTitle}
          </div>
          <div className="cart-single-page__confirmation-copy">
            {staticText.getIn(['data', 'welcomeBackCopy'])}
          </div>
          <Button
            type={TYPES.PRIMARY}
            url={getConfirmationFinishUrl(onboardingCompleted, isAiOnly)}
            className="cart-single-page__confirmation-button"
          >
            <span>{staticText.getIn(['data', 'startWatching'])}</span>
            <Icon size={36} color={ICON_COLORS.WHITE} >
              <ArrowRightIcon />
            </Icon>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default compose(
  connectStaticText({ storeKey: 'CartSinglePage' }),
  connectRedux(
    (state) => ({
      userAccount: state.userAccount,
      onboarding: state.onboarding,
      user: state.user,
    }),
  ),
)(CartSinglePageConfirmation)
